// extracted by mini-css-extract-plugin
export default {"address":"ContactUs_address__f-MB6","link":"ContactUs_link__fZN7r"};